import React from "react"
import IconButton from "@mui/material/IconButton"
import Stack from "@mui/material/Stack"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import NavigateNextIcon from "@mui/icons-material/NavigateNext"
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore"
import { useDispatch } from "react-redux/es/hooks/useDispatch"
import { useSelector } from "react-redux"
import dayjs from "dayjs"
import { setWeekPaginationState } from "./model/weekPagination"
import Button from "@mui/material/Button"
// import { setWeekPaginationState } from "./model/weekPagination"

const CustomTableWeekPagination = ({ weekPagination }: any) => {
  const dispatch = useDispatch()

  const currentWeek = useSelector(
    (state: any) => state.weekPagination.currentWeek,
  )
  const startOfWeek = dayjs(currentWeek).startOf("week")
  const endOfWeek = dayjs(currentWeek).endOf("week")

  const goToPreviousWeek = () => {
    const newWeek = dayjs(currentWeek).subtract(1, "week").format("YYYY-MM-DD")
    dispatch(setWeekPaginationState(newWeek))
  }

  const goToNextWeek = () => {
    const newWeek = dayjs(currentWeek).add(1, "week").format("YYYY-MM-DD")
    dispatch(setWeekPaginationState(newWeek))
  }

  const goToToday = () => {
    const today = dayjs().format("YYYY-MM-DD")
    dispatch(setWeekPaginationState(today))
  }

  return (
    <Stack
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      spacing={"20px"}
      sx={{ mt: "20px" }}
    >
      <Button
        sx={{ fontWeight: "bold", width: "90px" }}
        variant="outlined"
        size="small"
        onClick={goToToday}
      >
        Сегодня
      </Button>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={"10px"}
      >
        <IconButton
          onClick={goToPreviousWeek}
          aria-label="previous"
          size="small"
        >
          <NavigateBeforeIcon />
        </IconButton>
        <Typography>
          {startOfWeek.format("DD.MM.YYYY")} - {endOfWeek.format("DD.MM.YYYY")}
        </Typography>
        <IconButton onClick={goToNextWeek} aria-label="next" size="small">
          <NavigateNextIcon />
        </IconButton>
      </Stack>
    </Stack>
  )
}

export default CustomTableWeekPagination
